import { render, staticRenderFns } from "./MergeTag.vue?vue&type=template&id=a8b27f32&scoped=true"
import script from "./MergeTag.vue?vue&type=script&lang=js"
export * from "./MergeTag.vue?vue&type=script&lang=js"
import style0 from "./MergeTag.vue?vue&type=style&index=0&id=a8b27f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b27f32",
  null
  
)

export default component.exports